<template>
    <div>
        <mobile-naigation />

        <v-flex-container center>
            <v-card-container>
                <v-card>
                    <div v-padding.xs.top="3" v-padding.md.left="8" v-padding.md.right="8" v-padding.xs.left="2" v-padding.xs.right="2">
                        <v-form :validate="validateForm" @submit="handleSubmit">
                            <template scope="api">
                                <v-form-input field="username" :readonly="isRecovering" label="Email" />
    
                                <div v-margin.top="4">
                                    <v-spinner block :active="isRecovering">
                                        <v-green-button :disabled="api.isInvalid || isRecovering" type="submit" primary block>
                                            ВОССТАНОВИТЬ
                                        </v-green-button>
                                    </v-spinner>
    
                                    <div v-if="serverError" v-padding.top="1">
                                        <v-text danger>
                                            {{ serverError }}
                                        </v-text>
                                    </div>
                                </div>
                            </template>
                        </v-form>
    
                        <div v-if="successMessage" v-padding.top="3">
                            <v-text>
                                {{successMessage}}
                            </v-text>
                        </div>
    
                        <div v-text-align.center v-padding.top="4" v-padding.bottom="4">
                            <v-router-link size="subheadling" :to="{ name: 'login' }">
                                <v-button flat primary>
                                    Войти
                                </v-button>
                            </v-router-link>
                        </div>
                    </div>
                </v-card>
            </v-card-container>
        </v-flex-container>

        <v-flex-container center>
            <v-card-container>
                <!-- <div v-text-align.center v-padding.top="3" v-padding.bottom="9">
                    <v-text>
                        Еще не зарегистрировались?
                        <v-router-link :to="{ name: 'register' }">
                            Зарегистрируйтесь
                        </v-router-link>
                    </v-text>
                </div> -->
            </v-card-container>
        </v-flex-container>
    </div>
</template>
<script>
    import MobileNaigation from '../MobileNaigation';
    import {
        vCard,
        vCardContainer,
        vFlexContainer,
        vButton,
    } from '../baseComponents';

    import { validate, isRequired, isEmail } from '../../../services/validator';

    function validateRecoveryForm(values) {
        const recoveryRules = {
            username: [
                (val) => isRequired(val, 'Введите email'),
                (val) => isEmail(val),
            ],
        };

        return validate(values, recoveryRules);
    }

    export default {
        name: 'recovery',
        props: {
            onRecovery: Function,
        },
        components: {
            vCard,
            vCardContainer,
            vFlexContainer,
            MobileNaigation,
            vGreenButton: vButton,
        },
        data() {
            return {
                isRecovering: false,
                serverError: undefined,
                successMessage: undefined,
            }
        },
        methods: {
            validateForm(values) {
                return validateRecoveryForm(values);
            },
            handleSubmit({ username }) {
                if (this.isRecovering) {
                    return;
                }

                this.isRecovering = true;
                this.serverError = undefined;
                this.successMessage = undefined;

                this.onRecovery(username)
                    .then(() => {
                        this.isRecovering = false;
                        this.successMessage = /@/.test(username)
                            ? 'На вашу почту отправлено письмо с новым паролем.'
                            : 'На ваш телефон отправлено смс с новым паролем.';
                    })
                    .catch((res) => {
                        this.isRecovering = false;
                        this.serverError = res.message;
                    });
            },
        }
    }
</script>



// WEBPACK FOOTER //
// Recovery.vue?fcc91c34